import { gql } from '@apollo/client';

export interface CallsResponse {
  hostGroupsOverview: Array<{ id: number; title: string }>;
  hostsOverview: Array<{
    id: number;
    group_id: number;
    admin_called_at?: string;
    alias: string;
  }>;
}
export const CALLS = gql`
  query adminCalls {
    hostGroupsOverview {
      id
      title
    }
    hostsOverview {
      id
      group_id
      admin_called_at
      alias
    }
  }
`;

export interface ICallDoneRequest {
  id: number;
}
export interface ICallDoneResponse {
  adminCallDone: boolean;
}
export const CALL_DONE = gql`
  mutation adminCallDone($id: Int!) {
    adminCallDone(id: $id)
  }
`;

export const CALL_FRAGMENT = gql`
  fragment call on HostOverview {
    admin_called_at
  }
`;
